import imageCompression from 'browser-image-compression';
import { convertHeicToJPEG, isHEICFile } from '@/utilities/heicUtility.js'

export async function convertAndCompressImage(file, customOptions = {}) {
  
  try {
    const JPEGImage = isHEICFile(file) ? await convertHeicToJPEG(file) : file

    if (JPEGImage.size < 1048576) { // Image size < 1MB (1048576 bytes)
      return JPEGImage
    }
    
    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
      ...customOptions
    };

    try {
      const compressedFile = await imageCompression(JPEGImage, options);
      return compressedFile;
    } catch (compressionError) {
      console.error("Compression failed, returning JPEG image:", compressionError);
      return JPEGImage; // Return already converted, uncompressed image
    }
  } catch (error) {
    console.error("Error convert HEIC image, returning original file:", error)
    return file // Returns the original image on error in convertHeicImage
  }
}